module.exports = __webpack_public_path__ + "static/media/eu_trab.fd87f25a.jpeg";